<!-- Hero Section -->
<section
  id="about-hero"
  class="w-100 text-light"
  style="margin-top: 66px; background: linear-gradient(45deg, #1a2042, #173580)">
  <div class="container py-5">
    <div class="text-center">
      <!-- Left: About intro -->
      <div class="mb-4 mb-lg-0">
        <h1 class="fw-bold mb-4">Contact Us</h1>
        <p class="lead mb-4">
          We are a team of passionate traders and educators with a mission to empower individuals by
          providing accessible, high-quality education.
        </p>
        <button class="btn btn-outline-light px-4 py-2 rounded-2 shadow-sm mt-3"
        (click)="navigateAndScroll('/contact','form')">
          Connect with Us
        </button>
      </div>

      <!-- Right: Achievements -->
    </div>
  </div>
</section>
<section id="courses" class="py-5 bg-light">
  <div class="container">
    <div class="row align-items-center">
      <!-- Left -->
      <!-- Left -->
      <div class="col-lg-6 pe-lg-5">
        <h2 class="fw-bold mb-4">Get in Touch With Us</h2>
        <p class="lead mb-4 fw-normal" style="color: gray;">
          Have questions about our courses, need technical assistance, or looking to explore
          partnership opportunities? At <strong>ChalkBasket</strong>, we’re here to support
          you every step of the way. Our dedicated support team and education specialists are ready
          to provide clear guidance, helpful resources, and the right solutions whenever you need
          them.
        </p>
        <h4 class="fw-semibold mt-4" >Reach out to us for:</h4>
        <ul class=" mb-4 lead fw-normal" style="color: gray;">
          <li class="ml-0 mb-2 lead fw-normal">Course information, enrollment, and pricing</li>
          <li class="mb-2"> Technical support and platform assistance</li>
          <li class="mb-2"> Partnership or collaboration opportunities</li>
          <li class="mb-2"> General inquiries, feedback, and suggestions</li>
          <li class="mb-2"> Career guidance and certification support</li>
        </ul>
        <p class="mb-4 lead fw-normal"style="color: gray;">
          We aim to respond to all inquiries within <strong>24 business hours</strong>. Your growth
          and success in education are our priority, and we’re committed to helping you
          achieve your learning goals.
        </p>
        <p class="lead fw-normal" style="color: gray;">📧 Send us a message today — we’ll be glad to assist you!</p>
      </div>

      <!-- Right: Form -->
      <div class="col-lg-6">
        <div class="card shadow p-4 p-lg-5 m-3 rounded-3" style="border-radius: 10px;
            border-top: 5px solid #00346b;">
          <h2 class="text-center mb-4">Contact Us</h2>
          <form id="form">
            <div class="mb-3">
              <label for="name" class="form-label fw-semibold mb-2">Name</label>
              <input type="text" class="form-control p-3 rounded-2 mb-4" id="name" required />
            </div>
            <div class="mb-3">
              <label for="email" class="form-label fw-semibold mb-2">Email Id</label>
              <input type="email" class="form-control p-3 rounded-2 mb-4" id="email" required />
            </div>

            <div class="mb-4">
              <label for="Suggestion" class="form-label fw-semibold mb-2"
                >Suggestion/Comments
              </label>
              <textarea class="form-control p-3 rounded-2 mb-4"></textarea>
            </div>
            <button
              type="buttom"
              class="btn btn-primary w-100 fw-semibold px-4 py-3 mt-3 rounded-2"
              (click)="changeClass()"
              style=" background: linear-gradient(45deg, #1a2042, #173580); color: #fff"
            >
              send
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<div #popup class="popdown card position-fixed bottom-0 w-100 bg-light h-full position-relative">
  <div class="p-5 position-relative">
    <div class="d-flex text-end">
    <span class="fs-2 me-2 ms-auto" style="cursor: pointer;" (click)="hidePopup()">X</span>  
    </div>    
    <!-- <h1 class="position-absolute end-0" style="cursor: pointer;" >X</h1> -->
    <div class="text-center">
      <img src="https://via.placeholder.com/150x150?text=Thank+You" alt="Thank You for Your Suggestion">
      <h2>We Appreciate Your Feedback!</h2>
      <p>Thank you for sharing your valuable suggestion with us.</p>
      <p>Your input helps us improve and create better experiences for our learners and community.</p>
      <h4>What Happens Next?</h4>
      <p>✔ Our team will review your suggestion carefully.</p>
      <p>✔ If it can be implemented, we’ll share updates with you via email.</p>
      <p>✔ Meanwhile, stay tuned for upcoming workshops and resources.</p>
      <p>We truly value your time and effort in helping us grow!</p>
      <button class="btn btn-primary mt-3">Explore More Workshops</button>
    </div>
  </div>
</div>

